/* external dependencies */
import 'babel-polyfill';
import Vue from 'vue';
import ElementUI from 'element-ui';
import ElLoading from 'element-ui/lib/loading';
import elementKoLocale from 'element-ui/lib/locale/lang/ko';
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import merge from 'element-ui/lib/utils/merge';
import VueI18n from 'vue-i18n';
import VueHighcharts from 'vue-highcharts';
import highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import loadMap from 'highcharts/modules/map';
import loadStock from 'highcharts/modules/stock';
import solidgauge from 'highcharts/modules/solid-gauge';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
import boost from 'highcharts/modules/boost';
import exporting from 'highcharts/modules/exporting';
import vmodal from 'vue-js-modal';
import contentmenu from 'v-contextmenu';
import VueNativeSock from 'vue-native-websocket';
import VueQuillEditor from 'vue-quill-editor';
import taskManager from '@/utils/task-manager';
import Carousel3d from 'vue-carousel-3d';
import VueParticles from 'vue-particles';
import fabric from 'fabric';
import Notifications from 'vue-notification';
// import VueGragh from 'vue-graph';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-pro/css/all.css';

/* relative dependencies */
import 'element-ui/lib/theme-chalk/index.css';
import 'v-contextmenu/dist/index.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import './assets/scss/base.scss';
import './assets/img/favicon.ico';

import ElTree from './extends/element-ui/tree';
import ElTableWrapper from './components/external/el-table-wrapper';
import WToolTabs from './components/tabs/ToolTabs';
import WHeaderSearchButton from './components/button/HeaderSearchButton';
import WScrollTopButton from './components/button/ScrollTopButton';
import WSlidingPopup from './components/popup/SlidingPopup';
import WSettingSlidingPopup from './components/popup/SettingSlidingPopup';
import WPanel from './components/box/Panel';
import WEventlevelCombo from './components/form/EventlevelCombo';
import App from './App';
import router from './router';
import store from './store';
import './permission';
import './axios';

// i18n
Vue.use(VueI18n);
// jshint ignore:start
const messages = {
  ko: {
    message: '안녕',
    ...elementKoLocale,
  },
  en: {
    message: 'hello',
    ...elementEnLocale,
  },
};
// jshint ignore:end
const i18n = new VueI18n({
  locale: 'ko',
  messages,
});

// element-ui
Vue.use(ElementUI, {
  size: 'mini',
  i18n: (key, value) => i18n.t(key, value),
});

// element-ui Loading
Vue.use(ElLoading);

// highcharts
loadMap(highcharts);
loadStock(highcharts);
highchartsMore(highcharts);
solidgauge(highcharts);
boost(highcharts);
noDataToDisplay(highcharts);
exporting(highcharts);
highcharts.setOptions({
  exporting: {
    enabled: false,
  },
  global: {
    useUTC: false,
  },
  lang: {
    noData: '',
    thousandsSep: ',',
    resetZoom: '되돌리기',
    resetZoomTitle: '되돌리기',
  },
  chart: {
    style: {
      fontFamily: '\'Lato\', \'Noto Sans KR\', sans-serif',
    },
  },
});

Vue.use(VueHighcharts, { highcharts });
Vue.prototype.Highcharts = highcharts;

// WebSocket
Vue.use(VueNativeSock, 'ws://127.0.0.1:51255', {
  store,
  connectManually: true,
});

Vue.use(VueQuillEditor);

// 커스텀 컴포넌트 설치
Vue.use(ElTree);
Vue.use(ElTableWrapper);
Vue.use(WToolTabs);
Vue.use(WHeaderSearchButton);
Vue.use(WScrollTopButton);
Vue.use(WSlidingPopup);
Vue.use(WSettingSlidingPopup);
Vue.use(WPanel);
Vue.use(WEventlevelCombo);
Vue.use(Carousel3d);
Vue.use(VueParticles);
Vue.use(fabric);
Vue.use(Notifications, { name: 'pushNotification' });

// 컨텍스트 메뉴
Vue.use(contentmenu);

// 모달 팝업
Vue.use(vmodal, {
  dynamic: true,
});

Vue.config.productionTip = false;

// element-ui confirm message box override
Vue.prototype.$confirm = (message, title, options) => {
  if (typeof title === 'object') {
    options = title; // eslint-disable-line
    title = ''; // eslint-disable-line
  } else if (title === undefined) {
    title = ''; // eslint-disable-line
  }
  return Vue.prototype.$msgbox(merge({
    title,
    message,
    $type: 'confirm',
    showCancelButton: true,
    // center: true,
    customClass: 'confirm-box',
  }, options));
};

Vue.prototype.$taskManager = taskManager;

// Vue.use(VueGragh);
// Vue.prototype.VueGragh = VueGragh;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js